import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Play } from 'lucide-react';
import { DjayAvatar, useDjaySelection } from '../../mascot';
import { humanizeFamilyId } from '../../content';
import { getEnabledModes } from '../../modes';
import { tapSpring, hoverLift } from '../../components/shared/motionPresets';
import { soundManager } from '../../utils/soundManager';
import { hapticManager } from '../../utils/hapticManager';
interface ContinueStripProps {
  modeId: string;
  familyId?: string;
  score?: number;
  timestamp: number;
  onContinue: () => void;
}
export function ContinueStrip({
  modeId,
  familyId,
  score,
  timestamp,
  onContinue
}: ContinueStripProps) {
  const {
    selectedVariant
  } = useDjaySelection();
  const mode = getEnabledModes().find(m => m.id === modeId);
  if (!mode) return null;
  const handleClick = () => {
    soundManager.playClick();
    hapticManager.hapticLight();
    onContinue();
  };
  return <motion.button onClick={handleClick} {...tapSpring} {...hoverLift} className="w-full bg-white rounded-2xl p-3 sm:p-4 shadow-sm border border-slate-200 flex items-center gap-4 group text-left" data-id="element-3047" data-mp="3oytn6udxok9e">
      <div className="flex-shrink-0 w-10 h-10 bg-slate-50 rounded-full flex items-center justify-center border border-slate-100" data-id="element-3048" data-mp="1ibnaxgu0svba">
        <DjayAvatar size="sm" emotion="encouraging" variant={selectedVariant} animate={false} data-id="element-3049" data-mp="19dbm9kcps7lh" />
      </div>

      <div className="flex-1 min-w-0" data-id="element-3050" data-mp="260yet76o35tn">
        <div className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-0.5" data-id="element-3051" data-mp="213g87ng4h2ot">
          Verder waar je was
        </div>
        <div className="text-sm font-bold text-slate-800 truncate" data-id="element-3052" data-mp="1x0t9r3oy4jin">
          {mode.title}
          {familyId && <span className="text-slate-500 font-medium" data-id="element-3053" data-mp="1s5dwodyrirna">
              {' '}
              — {humanizeFamilyId(familyId)}
            </span>}
        </div>
        {score !== undefined && <div className="text-xs text-slate-500 mt-0.5" data-id="element-3054" data-mp="gq7cl22of53d">
            Vorige score:{' '}
            <span className="font-bold text-slate-700" data-id="element-3055" data-mp="i374yu5meh3m">{score}%</span>
          </div>}
      </div>

      <div className="flex-shrink-0 flex items-center gap-2 text-indigo-600" data-id="element-3056" data-mp="n2a8ub9v6ha0">
        <span className="text-xs font-bold hidden sm:inline-block" data-id="element-3057" data-mp="94259kibohpv">
          Doorgaan
        </span>
        <div className="w-8 h-8 rounded-full bg-indigo-50 flex items-center justify-center group-hover:bg-indigo-100 transition-colors" data-id="element-3058" data-mp="d4dpwxaoqi1c">
          <ArrowRight className="w-4 h-4" data-id="element-3059" data-mp="45imfsz0zm1q" />
        </div>
      </div>
    </motion.button>;
}